import { motion } from "framer-motion";
import React, { FC } from "react";

export const Footer: FC<{}> = () => {
  return (
    <motion.footer layout>
      <div className="container ">
        <div className="row">
          <div className="logo col-6">
            <h1>
              Speed<span>nance.</span>
            </h1>
          </div>
          <div className="col-6 copyright">
            <h1>Copyright © 2022</h1>
          </div>
        </div>
      </div>
    </motion.footer>
  );
};
